import { useMemo } from 'react'
import { camelCase } from 'lodash'
import { not } from '@feedyou/utils'
import {
  Dictionary,
  NlpChatQuery,
  QueryListFilter,
  KnowledgeBaseQuery
} from '@feedyou-ai/feedbot-schema'

import { TableColumn, HideableColumn } from './types'
import { EMPTY_VALUES, HIDEABLE_COLUMNS } from './constants'
import { useStableArray } from '../../../lib/array/useStableArray'

export function useVisibleColumns(params: {
  filter: QueryListFilter
  columns: TableColumn[]
  queries: NlpChatQuery[] | KnowledgeBaseQuery[]
}): TableColumn[] {
  const { filter = {}, columns = [], queries = [] } = params
  const filterKeys = useStableArray(Object.keys(filter))
  return useStableArray(
    useMemo(
      () => columns.filter(not(isColumnHidden({ queries, filterKeys }))),
      [queries, columns, filterKeys]
    )
  )
}

function isColumnHidden(params: {
  queries: NlpChatQuery[] | KnowledgeBaseQuery[]
  filterKeys: string[]
}) {
  return (column: TableColumn): boolean =>
    HIDEABLE_COLUMNS.includes(column.name as HideableColumn) &&
    !(column.controls && params.filterKeys.includes(camelCase(column.name))) &&
    !params.queries.some(not(isEmptyValue(camelCase(column.name))))
}

function isEmptyValue(propertyName: string) {
  return (query: NlpChatQuery | KnowledgeBaseQuery): boolean => {
    const value = (query as Dictionary<string, any>)[propertyName]
    return EMPTY_VALUES.includes(typeof value === 'string' ? value?.trim() : value)
  }
}
